import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";

export class Unit {
  static units = [];

  static async install() {
    const response = await EnvironmentsAPI.getUnits();
    if (response.getData([]).length > 0) {
      Unit.units = response.getData([]);
    }
  }

  constructor(unitId) {
    this.id = unitId;
  }

  get name() {
    const unit = (Unit.units || []).find((unit) => unit.id == this.id);
    return unit?.name;
  }
}
